var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM5.98462 17.2472C4.45924 17.5996 4.00282 18.2469 3.87001 19.2749C5.86748 21.5054 8.76947 22.909 11.9993 22.909C15.229 22.909 18.131 21.5055 20.1284 19.275C19.996 18.2469 19.5397 17.5998 18.0146 17.2472L17.9248 17.2265C15.6146 16.6934 13.5009 16.2058 14.5442 14.2349C17.7624 8.15855 15.3971 4.909 11.9996 4.909C8.53462 4.909 6.22871 8.28332 9.45508 14.2349C10.5215 16.2015 8.37076 16.6972 6.12623 17.2145L5.98462 17.2472Z","fill":"currentColor"}));
}

User.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = User;

User.default = User;
